import { render, staticRenderFns } from "./KitchenSummary.vue?vue&type=template&id=13d2742c&scoped=true&"
import script from "./KitchenSummary.vue?vue&type=script&lang=js&"
export * from "./KitchenSummary.vue?vue&type=script&lang=js&"
import style0 from "./KitchenSummary.vue?vue&type=style&index=0&id=13d2742c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2742c",
  null
  
)

export default component.exports